import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../utils/config';
import ReactSelect from 'react-select'
import Loading from './loading';
import { Dialog} from '@mui/material';


const IndexIntradaySection = ({ stockSymbols, IntraDaychecked, SecondTarget, requestToken, commenteryData, isEditable, onOptionSectionChange, onOptionExpirySelect, onOptionStockSelect, onRemoveFile, onStockLossRecord, generateImage ,reportRef,handleEditableIndexFromReport }) => {
  const [optionSectionState, setOptionSectionState] = useState({
    optionReportType: 'BUY',
    stockType: 'NIFTY',
    optionCMP: '',
    optionSL: '0',
    strikePrice: '',
    stockIncToken: '',
    underlayingPrice: '',
    futureCMP: '',
    first_target: '',
    second_target: '',
    optionRemark: '',
    commentry: '',
    chartImageInterval: '1D',
    Expiry: '',
    Futureexpiry: '',
    volume: '',
    openInterest: '',
    lot_size: ''
  });
  const options = stockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft: '185px'
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };
  const [SelectedStockRecord, setSelectedStockRecord] = useState({});
  const [expiryData, setExpiryData] = useState([]);

  const [expiryshow, setexpiryshow] = useState(false);

  const [underlayingPriceerror, setunderlayingPriceError] = useState(false)

  const [optioncmperror, setOptionCmpError] = useState(false)

  const [strikePriceerror, setstrikePriceError] = useState(false)
  const [showCmpApiError, setShowCmpApiError] = useState(false)
  const [showFutureCmpApiError, setShowFutureCmpApiError] = useState(false)
  const [showStrikePriceApiError, setShowStrikePriceApiError] = useState(false)
  const [showAlert, setshowAlert] = useState(false);
  const [AlertMessage, setAlertMessage] = useState("");
  const [strikePriceData, setStrikePriceData] = useState([])
  const [optionCmpData, setOptionCmpData] = useState([])

  const [loading, setLoading] = useState(false);
  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'


  useEffect(() => {
    if (commenteryData && commenteryData.length > 0) {
      handlechangestock(optionSectionState.stockType, optionSectionState.optionReportType);
      const getSelectedCommentary = (type) => {
        console.log("commertry data ", commenteryData)
        const label = type === 'BUY' ? 'Intraday/BTST Buy' : 'Intraday/BTST Sell';
        return commenteryData.find(data => data.CommentaryName === label) || null;
      };

      const selectedData = getSelectedCommentary(optionSectionState.optionReportType);
      console.log("Selected commentry", selectedData)
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          commentry: selectedData?.Description || '',
        }

        onOptionSectionChange(newState);

        return newState;
      })
    }
  }, [commenteryData]);


 // handle input change of the input fields
  const handleInputChange = (event) => {
    setunderlayingPriceError(false);
    setOptionCmpError(false);
    setstrikePriceError(false);
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setOptionSectionState((prevState) => {
        let newState
        if (name === 'second_target' && value.trim() === '') {
          newState = {
            ...prevState,
            [name]: null,

          };
        }
        else if (name === 'optionSL' && value == '0') {

          newState = {
            ...prevState,
            [name]: value,
            optionRemark: RemarkText
          };
        }
        else if (name === 'optionSL' && value != '0') {
          newState = {
            ...prevState,
            [name]: value,
            optionRemark: ""
          };
        }
        else {
          newState = {
            ...prevState,
            [name]: value,

          };
        }


        // Log the updated state
        console.log("OptionSectionState", newState);

        // Notify the parent component about the change
        onOptionSectionChange(newState);

        return newState;
      });
    }
    else {
      if (name === 'optionCMP') {
        setOptionCmpError(true)
        setTimeout(() => {
          setOptionCmpError(false)
        }, 2000);
      }
      else if (name === 'underlayingPrice') {
        setunderlayingPriceError(true)
        setTimeout(() => {
          setunderlayingPriceError(false)
        }, 2000);
      }
      // else if (name === 'first_target') {
      //   setFirstTargetError(true)
      //   setTimeout(() => {
      //     setFirstTargetError(false)
      //   }, 2000);
      // }
      // else if (name === 'second_target') {
      //   setSecondTargetError(true)
      //   setTimeout(() => {
      //     setSecondTargetError(false)
      //   }, 2000);
      // }
      else if (name === 'strikePrice') {
        setstrikePriceError(true)
        setTimeout(() => {
          setstrikePriceError(false)
        }, 2000);
      }
      // else if (name === 'optionSL') {
      //   setSlError(true)
      //   setTimeout(() => {
      //     setSlError(false)
      //   }, 2000);
      // }
      // else if (name === 'volume') {
      //   setVolumeError(true)
      //   setTimeout(() => {
      //     setVolumeError(false)
      //   }, 2000);
      // }
    }

  };


//  handle change for radio button for sell or buy
  const handleChange = (event) => {

    const { name, value } = event.target;
    console.log("value chang eon option type", value)
    if (name === 'optionReportType') {

      const getSelectedCommentary = (type) => {
        const label = type == 'BUY' ? 'Intraday/BTST Buy' : 'Intraday/BTST Sell';
        console.log("label", label)
        let data = commenteryData.find(data => data.CommentaryName === label) || null;
        console.log("data", data)
        return data
      };

      const selectedData = getSelectedCommentary(value);

      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionReportType: value,
          stockType: 'NIFTY',
          optionCMP: '',
          optionSL: '0',
          strikePrice: '',
          stockIncToken: '',
          underlayingPrice: '',
          futureCMP: '',
          commentry: selectedData?.Description || '',
          first_target: '',
          second_target: '',
          optionRemark: '',
          chartImageInterval: '1D',
          Expiry: '',
          volume: '',
          openInterest: '',
          lot_size: ''
        }

        onOptionSectionChange(newState);

        return newState;
      })
      setExpiryData([])
      setexpiryshow(false)
      handlechangestock('NIFTY', value)
    } else {
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
        };

        // Log the updated state
        console.log("OptionSectionState", newState);

        // Notify the parent component about the change
        onOptionSectionChange(newState);

        return newState;
      });
    }



  };

// handle chart interval for chart image
  const handleChartinterval = (event) => {

    const { name, value } = event.target;
     if (!optionSectionState.stockType || !optionSectionState.Expiry) {
    console.log("Stock symbol not available. Skipping interval change.");
    setAlertMessage(`Please Select Stock Name and Expiry First then try to change the Image Interaval.`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    return;
  }
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onOptionSectionChange(newState);


      // generateImage(SelectedStockRecord.TV_STOCK_Symbol, SelectedStockRecord.TVExchange, value)
      return newState;
    });


  };

// handle stock name change to create stock signal report
  const handlechangestock = async (value, reporttype) => {
    console.log("value", value)
    reportRef.current?.resetReportAlreadySuccess();
    handleEditableIndexFromReport();
    const stockName = typeof value === 'object' && value !== null ? value.name : value;
    const reportType = typeof value === 'object' && value !== null ? optionSectionState.optionReportType : reporttype;

    // const { name, value } = event.target;
    setLoading(true)
    let selectedStockRecord
    let type 
    if(stockName === "SENSEX"){
     type = 'BFO-OPT'
    }else{
      type = 'NFO-OPT';
    }
    let last_price
    let Expiry_date
    let futexpiryData


    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: stockName,
        optionCMP: "",
        optionSL: '0',
        strikePrice: "",
        underlayingPrice: '',
        futureCMP: '',

        first_target: '',
        second_target: '',
        optionRemark: '',
        Expiry: '',
        volume: ''
      };

      onRemoveFile();

      console.log(stockSymbols);
      selectedStockRecord = stockSymbols.find(item => item.name === stockName);

      console.log("selectedStockRecord inside setoptiondata", selectedStockRecord);

      setSelectedStockRecord(selectedStockRecord);

      onOptionStockSelect(selectedStockRecord);
      onOptionSectionChange(newState);
      // generateImage(selectedStockRecord.TV_STOCK_Symbol, selectedStockRecord.TVExchange, optionSectionState.chartImageInterval)

      return newState;
    });

    setStrikePriceData([]);
    setOptionCmpData([]);




    let nameStock = ''
    if (stockName === 'NIFTY') {
      nameStock = `I${stockName}`
    } else {
      nameStock = stockName
    }

    console.log("selectedStockRecord outsiden setoptiondata", selectedStockRecord);


    // expiry select default index 0
    if (nameStock !== '' || type !== '') {
      await fetch(`${BASE_URL}/getstockexpiry/${nameStock}/${type}`, {
        method: 'GET'
      })
        .then(response => response.json())
        .then(res => {
          // Process the API response data
          console.log(res);

          if (res.success === true) {
            console.log("res.data", res.data);

            let expiryData

            if (stockName === 'NIFTY') {
            
              expiryData = JSON.parse(res.data[0].dates);

            futexpiryData = JSON.parse(res.data[0].Future_Expiry);

            console.log("expiryData", expiryData);
            console.log("futexpiryData", futexpiryData[0].expiry);
            if (expiryData.length === 0) {
              alert("Expiry data is not available For Option.")
            }

            if (futexpiryData.length === 0 && futexpiryData[0].expiry !== undefined) {
              alert("Expiry data is not available For Future.")
            }

            setExpiryData(expiryData)

            setexpiryshow(true)

          } else {
            expiryData = JSON.parse(res.data[0].dates);
            futexpiryData = JSON.parse(res.data[0].Future_Expiry);

            console.log("expiryData", expiryData);
            console.log("futexpiryData", futexpiryData[0].expiry);
            if (expiryData.length === 0) {
              alert("Expiry data is not available For Option.")
            }

            if (futexpiryData.length === 0 && futexpiryData[0].expiry !== undefined) {
              alert("Expiry data is not available For Future.")
            }

            setExpiryData(expiryData)

            setexpiryshow(true)
          }

            Expiry_date = expiryData[0].expiry

            setOptionSectionState((prevState) => {
              const newState = {
                ...prevState,
                Expiry: expiryData[0].expiry,
                Futureexpiry: futexpiryData[0].expiry,
              };

              onOptionSectionChange(newState);

              return newState;
            });
          } else {
           
            setAlertMessage(`Error: ${res.message}`)
          setshowAlert(true)
       setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
       }, 2000);
       return
          }

        })
        .catch(error => {
          // Handle errors
          console.error('Error fetching data:', error);
          setAlertMessage(`Error: ${error.message}`)
          setshowAlert(true)
       setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
       }, 2000);
       return
        });
    } else {
       setAlertMessage(`Please Select Stock Name`)
       setshowAlert(true)
       setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
       }, 2000);
       return
    }

    if (futexpiryData.length > 0 && futexpiryData[0].expiry !== undefined && Expiry_date !== undefined) {

      let url
      if (IntraDaychecked) {
        url = `${BASE_URL}/getcmpprice/${stockName}/${'IntraDay'}/${futexpiryData[0].expiry}`
      } else {
        url = `${BASE_URL}/getcmpprice/${stockName}/${requestToken}/${Expiry_date}`
      }
      // get cmp of stock
      await fetch(`${url}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(response => response.json())
        .then(res => {
          // Process the API response data
          console.log(res);

          if (res.success === true) {
            console.log("res.data for cmp price -====", res);

            if (IntraDaychecked) {
              let Stock_IncToken = res.instruments.instrument_token
              let futurecmp_token = res.futurecmp_token
              console.log("Future token", futurecmp_token)
              console.log("Stock_IncToken", Stock_IncToken)
              last_price = res.instruments
              last_price = last_price.last_price
              console.log("res.Futurecmp", res.Futurecmp)
              let futurecmp
              if (res.Futurecmp === undefined) {
                futurecmp = ''
              } else {
                futurecmp = res.Futurecmp
                futurecmp = futurecmp.last_price
              }

              setOptionSectionState((prevState) => {
                const newState = {
                  ...prevState,
                  optionCMP: last_price,
                  stockIncToken: Stock_IncToken,
                  futureCMP: futurecmp,
                  FutureIncToken: futurecmp_token
                };

                // Log the updated state
                console.log("OptionSectionState", newState);

                // Notify the parent component about the change
                onOptionSectionChange(newState);

                return newState;
              });
            } else {
              let Stock_IncToken = res.stock_IncToken
              last_price = res.instruments
              last_price = last_price.last_price

              setOptionSectionState((prevState) => {
                const newState = {
                  ...prevState,
                  optionCMP: last_price,
                  stockIncToken: Stock_IncToken

                };

                // Log the updated state
                console.log("OptionSectionState", newState);

                // Notify the parent component about the change
                onOptionSectionChange(newState);

                return newState;
              });
            }

       



            // console.log("expiryData", expiryData);
          } else {
            setAlertMessage(res.message)
            setShowCmpApiError(true)
            setOptionSectionState((prevState) => {
              const newState = {
                ...prevState,
                optionCMP: "",
                stockIncToken: '',
              };

              // Log the updated state
              console.log("OptionSectionState", newState);

              // Notify the parent component about the change
              onOptionSectionChange(newState);

              return newState;
            });
            setTimeout(() => {
              setShowCmpApiError(false)
              setAlertMessage('')
            }, 1000);
            return
          }


        })
        .catch(error => {
          setAlertMessage(`Error: ${error.message}`)
          setShowCmpApiError(true)
          setOptionSectionState((prevState) => {
            const newState = {
              ...prevState,
              optionCMP: "",
            };

            // Log the updated state
            console.log("OptionSectionState", newState);

            // Notify the parent component about the change
            onOptionSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowCmpApiError(false)
            setAlertMessage('')
          }, 1500);
          console.error('Error fetching data:', error);
          return
        });
    } else {
  
      setAlertMessage("OPtion Or Future Expiry Not Found.")
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
      }, 2000);
    }


    //  console.log("values",body )
    if (
      stockName !== '' ||
      Expiry_date !== '' ||
      optionSectionState.optionReportType !== '' ||
      last_price !== ''
    ) {
      console.log("inside the indexintraday strike price type", reportType)
      let body = JSON.stringify({
        stock_name: stockName,
        tvsymbol: selectedStockRecord.TV_STOCK_Symbol,
        expiry: Expiry_date,
        optionType: reportType,
        cmpPrice: last_price,
        intraDaychecked: IntraDaychecked
      })

      await fetch(`${BASE_URL}/getIndexIntradaystrikePrice`, {
        method: 'POST',
        body,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(response => response.json())
        .then(res => {
          // Process the API response data
          console.log("strike prices respounse", res);

          if (res.success === true) {
            let record = res.data
            // let nearestValue 

            // let StopLossVolumeData = res.StopLossVolumeData
            let optionData = res.optioncmpData
            setStrikePriceData(record);
            setOptionCmpData(optionData);


            // let tvRecord = StopLossVolumeData[0].tvRecord
            // let selectedRecord = null
            // for (let i = 0; i < tvRecord.length; i++) {
            //   const record = tvRecord[i];

            //   if (optionSectionState.optionReportType === "CALL") {
            //     if (selectedRecord === null || record.low < selectedRecord.low) {
            //       selectedRecord = record;
            //     }
            //   } else if (optionSectionState.optionReportType === "PUT") {
            //     if (selectedRecord === null || record.high > selectedRecord.high) {
            //       selectedRecord = record;
            //     }
            //   }
            // }
            onOptionExpirySelect(res.data[0]);
            // onStockLossRecord(selectedRecord);

            // console.log("StopLossVolumeData", StopLossVolumeData[0])
            setOptionSectionState((prevState) => {
              let newState = {
                ...prevState,
                strikePrice: record[0].strike,
                underlayingPrice: optionData[0].last_price,
                first_target: optionData[0].first_target,
                second_target: optionData[0].second_target,
                optionSL:optionData[0].last_price - 45,
                lot_size: optionData[0].lot_size,
                optionRemark: ''
              };


              onOptionSectionChange(newState);

              return newState;
            });

            setLoading(false)

          }
          else {
            setAlertMessage(res.message)
            setLoading(false)
            setShowStrikePriceApiError(true)
            setOptionSectionState((prevState) => {
              const newState = {
                ...prevState,
                strikePrice: "",
                underlayingPrice: '',
                first_target: '',
                second_target: '',
                lot_size: '',
                optionSL: '0',
                volume: "",
                openInterest: "",
                optionRemark: ""
              };

              onOptionSectionChange(newState);

              return newState;
            });
            setTimeout(() => {
              setShowStrikePriceApiError(false)
              setAlertMessage('')
            }, 1500);
            return
          }

        })
        .catch(error => {
          // Handle errors
          setAlertMessage(`Error: ${error.message}`)
          setLoading(false)
          setShowStrikePriceApiError(true)
          setOptionSectionState((prevState) => {
            const newState = {
              ...prevState,
              strikePrice: "",
              underlayingPrice: '',
              first_target: '',
              second_target: '',
              optionSL: '0',
              volume: "",
              openInterest: "",
              optionRemark: ''
            };

            // Log the updated state
            console.log("OptionSectionState", newState);

            // Notify the parent component about the change
            onOptionSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowStrikePriceApiError(false)
            setAlertMessage('')
          }, 1500);
          console.error('Error fetching data:', error);
          return
        });
    } else {
      setLoading(false)
      console.log("any value is empty from stockname , expiry ,reporttype, optioncmp")
      setAlertMessage(`Any value is empty from stockname , expiry ,reporttype, optioncmp`)
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 2000);
    }

  };

  // handle expiry change from expiry select
  const handlechangeExpiry = async (event) => {
    const { name, value } = event.target;

    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
        optionSL: '0',
        strikePrice: "",
        underlayingPrice: '',
        first_target: '',
        second_target: '',
        optionRemark: '',
        volume: ''
      };

      // Log the updated state

      onOptionSectionChange(newState);

      return newState;
    });


    setStrikePriceData([]);
    setOptionCmpData([]);

    fetchStrikePrice(value, 'Expiry');
  }

  // formate date time to use in expiry dropdown
  const formatDate = (dateString) => {
    // console.log("dateString",dateString)
    const dateObject = new Date(dateString);
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with a leading zero
    const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;

    return formattedDate;
  }

  // handle commnetry change
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    const selected = commenteryData.find(item => item.CommentaryName === value);

    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: selected?.Description || '',
      };

      onOptionSectionChange(newState);
      return newState;
    });
  };



// handle api call to fetch the current strike price
  const fetchStrikePrice = async (Value, type) => {

    // event.preventDefault();
    console.log("optionSectionState", optionSectionState);
    let body
    setLoading(true);
    if (type === 'Expiry') {


          const missingFields = [];

if (!optionSectionState.stockType) {
  missingFields.push("Stock Type");
}

if (!optionSectionState.optionCMP) {
  missingFields.push("Option CMP");
}

if (!optionSectionState.Expiry) {
  missingFields.push("Expiry");
}

      if(missingFields.length > 0){
        setLoading(false)
         setAlertMessage(
    `Missing Required Value: ${missingFields.join(", ")}`
  );
       setshowAlert(true)
       setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
       }, 2000);
       return
      }
      else{
        body = JSON.stringify({
        stock_name: optionSectionState.stockType,
        tvsymbol: SelectedStockRecord.TV_STOCK_Symbol,
        expiry: Value,
        optionType: optionSectionState.optionReportType,
        cmpPrice: optionSectionState.optionCMP,
        intraDaychecked: IntraDaychecked
      })
    }
    } else {


      const missingFields = [];

if (!optionSectionState.stockType) {
  missingFields.push("Stock Type");
}

if (!optionSectionState.optionCMP) {
  missingFields.push("Option CMP");
}

if (!optionSectionState.Expiry) {
  missingFields.push("Expiry");
}

      if(missingFields.length > 0){
        setLoading(false)
         setAlertMessage(
    `Missing Required Value: ${missingFields.join(", ")}`
  );
        setshowAlert(true)
        setTimeout(() => {
         setshowAlert(false)
         setAlertMessage('')
        }, 2000);
        return
      }else{
       
      body = JSON.stringify({
        stock_name: optionSectionState.stockType,
        tvsymbol: SelectedStockRecord.TV_STOCK_Symbol,
        expiry: optionSectionState.Expiry,
        optionType: optionSectionState.optionReportType,
        cmpPrice: Value,
        intraDaychecked: IntraDaychecked
      })
    }
    }

   
      await fetch(`${BASE_URL}/getIndexIntradaystrikePrice`, {
        method: 'POST',
        body,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(response => response.json())
        .then(res => {
          // Process the API response data
          console.log("strike prices respounse", res);

          if (res.success === true) {
            let record = res.data
            let optionData = res.optioncmpData
            setStrikePriceData(record);
            setOptionCmpData(optionData);

            let selectedRecord = null

            onOptionExpirySelect(res.data[0]);
            // console.log("selectedRecord",selectedRecord)
            onStockLossRecord(selectedRecord);

            setOptionSectionState((prevState) => {
              let newState

              newState = {
                ...prevState,
                strikePrice: record[0].strike,
                underlayingPrice: optionData[0].last_price,
                optionSL: optionData[0].last_price - 45,
                lot_size: optionData[0].lot_size,
                optionRemark: ''
              };

              // Notify the parent component about the change
              onOptionSectionChange(newState);

              return newState;
            });

            // onOptionExpirySelect(record)
            setLoading(false)
            // console.log("expiryData", expiryData);
          }
          else {
            setLoading(false)
            setAlertMessage(`Error: ${res.message}`)
            setShowStrikePriceApiError(true)
            setOptionSectionState((prevState) => {
              const newState = {
                ...prevState,
                strikePrice: "",
                underlayingPrice: '',
                first_target: "",
                second_target: "",
                lot_size: '',
                optionSL: '0',
                volume: "",
                openInterest: "",
                optionRemark: ""
              };

              // Log the updated state
              // console.log("OptionSectionState", newState);

              // Notify the parent component about the change
              onOptionSectionChange(newState);

              return newState;
            });
            setTimeout(() => {
              setShowStrikePriceApiError(false)
              setAlertMessage('')
            }, 1000);
          }

        })
        .catch(error => {
          // Handle errors
          setLoading(false)
          setAlertMessage(`Error: ${error.message}`)
          setShowStrikePriceApiError(true)
          setOptionSectionState((prevState) => {
            const newState = {
              ...prevState,
              strikePrice: "",
              underlayingPrice: '',
              first_target: "",
              second_target: "",
              optionSL: '0',
              volume: "",
              openInterest: "",
              optionRemark: ''
            };

            // Log the updated state
            console.log("OptionSectionState", newState);

            // Notify the parent component about the change
            onOptionSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowStrikePriceApiError(false)
            setAlertMessage('')
          }, 1000);
          console.error('Error fetching data:', error);
        });
   

  }





  return (
    <div className="optionmain">
      {loading ?
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}>
          <Loading />
        </div> : null}
      <div id="btnoptionDiv" className="btnoptiondiv">
        <p>BUY</p>
        <input type="radio" value="BUY" defaultChecked name="optionReportType" onChange={handleChange} />

        <p>SELL</p>
        <input type="radio" value="SELL" name="optionReportType" onChange={handleChange} />
      </div>

      <div id="option_content" className="optioncontent">
        <div>
          <p>Chart-Image Interval:</p>
          <select value={optionSectionState.chartImageInterval} id="chartImageInterval" name="chartImageInterval" onChange={handleChartinterval}>
            <option value="4h">4h</option>
            <option value="1D">1D</option>
            <option value="1W">1W</option>
            <option value="1M">1M</option>
            <option value="1Y">1Y</option>
          </select>
        </div>
        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>


          <ReactSelect
            id="OptionStocktype"
            name="stockType"
            options={options}
            value={options.find((opt) => opt.value === optionSectionState.stockType) || null}
            onChange={handlechangestock}
            styles={customStyles}
            disabled={!isEditable}
          />
        </div>

        {expiryshow ?
          <div style={{ marginTop: '16px' }}>
            <p>Expiry:<span className='asterisk'>*</span></p>
            <select id="optionexpiry" value={optionSectionState.Expiry} name="Expiry" required onChange={handlechangeExpiry} disabled={!isEditable}>
              <option value="">Select Expiry</option>
              {expiryData.map((expiry) => (
                <option key={expiry} value={expiry.expiry}>
                  {formatDate(expiry.expiry)}
                </option>
              ))}
            </select>
          </div>
          : null}

        {optioncmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{AlertMessage}</span> : null}
        <div style={{ marginTop: '16px' }}>
          <p>UnderLying Price:<span className='asterisk'>*</span></p>

          <input value={optionSectionState.optionCMP} type="number" id="optioncmp" name="optionCMP" required onChange={handleInputChange} disabled={!isEditable} />
        </div>


        <div style={{ marginTop: '16px' }}>
          <p>Future Expiry:<span className='asterisk'>*</span></p>

          <input value={optionSectionState.Futureexpiry} type="text" id="Futureexpiry" name="Futureexpiry" required disabled={!isEditable} />
        </div>

        {IntraDaychecked ? <div style={{ marginTop: '16px' }}>
          <p>Future CMP:<span className='asterisk'>*</span></p>

          <input value={optionSectionState.futureCMP} type="number" id="futurecmp" name="futureCMP" required onChange={handleInputChange} disabled={!isEditable} />
        </div> : null}

        {strikePriceerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showStrikePriceApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{AlertMessage}</span> : null}
        <div>
          <p>Strike Price:<span className='asterisk'>*</span></p>


          {strikePriceData.length > 0 ? (
            <>

              <input value={optionSectionState.strikePrice} type="number" id="strikePrice" name="strikePrice" required onChange={handleInputChange} disabled={!isEditable} />
            </>
          ) : (
            <input value={optionSectionState.strikePrice} type="number" id="strikePrice" name="strikePrice" required onChange={handleInputChange} disabled={!isEditable} />
          )}
        </div>


        {underlayingPriceerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showFutureCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{AlertMessage}</span> : null}
        <div>
          <p>Option CMP:<span className='asterisk'>*</span></p>

          {optionCmpData.length > 0 && optionCmpData.every(data => data.last_price !== undefined) ? (
            <>


              <input value={optionSectionState.underlayingPrice} type="number" id="underlayingprice" name="underlayingPrice" required onChange={handleInputChange} disabled={!isEditable} />
              {/* <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearUnderlayingPriceData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span> */}
            </>
          ) : (
            <input value={optionSectionState.underlayingPrice} type="number" id="underlayingprice" name="underlayingPrice" required onChange={handleInputChange} disabled={!isEditable} />
          )}
        </div>




        <div>
          <p>Option SL:</p>

          <input value={optionSectionState.optionSL} type="number" id="optionSL" name="optionSL" required  onChange={handleInputChange}/>


        </div>

        <div>
          <p>Lot Size:</p>

          <input value={optionSectionState.lot_size} type="number" id="lot_size" name="lot_size" readOnly required />


        </div>



        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select
            id="selectcommentry"
            name="commentry"
            value={
              commenteryData.find(item => item.Description === optionSectionState.commentry)?.CommentaryName || ''
            }
            onChange={handleOptionChange}
            disabled={!isEditable}
          >
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
              <option key={data.CommentaryName} value={data.CommentaryName}>
                {data.CommentaryName}
              </option>
            ))}
          </select>

        </div>


        <div>
          <p>Commentary Remarks:</p>
          <textarea style={{
            border: `2px solid rgba(0, 0, 0, 0.2)`,
            outline: 'none',
          }} value={optionSectionState.optionRemark} id="optionremark" name="optionRemark" required rows={4} onChange={handleChange} disabled={!isEditable} />
        </div>


      </div>

      <Dialog
                    open={showAlert}
                    onClose={() => { setshowAlert(false) }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
                  </Dialog>
    </div>
  );
};

export default IndexIntradaySection;
